(function($) {

    var typeSelector = {
        init: function(){
            $('[name="type"]').closest('.poly-select').addClass('loading');
            $('[name="type"]').prop('disabled', true);
        },
        update:function($data){
            $('[name="type"]').html($data);
        },
        reset:function($class){
            $('[name="type"]').removeClass($class);
        },
        updated:function($class){
            $('[name="type"]').addClass($class);
        },
        after: function(){
            $('[name="type"]').closest('.poly-select').removeClass('loading');
            $('[name="type"]').prop('disabled', false);            
        }
    };

    var industrySelector = {
        init: function(){
            $('[name="industry"]').closest('.poly-select').addClass('loading');
            $('[name="industry"]').prop('disabled', true);
        },
        update:function($data){
            $('[name="industry"]').html($data);
        },
        reset:function($class){
            $('[name="industry"]').removeClass($class);
        },
        updated:function($class){
            $('[name="industry"]').addClass($class);
        },        
        after: function(){
            $('[name="industry"]').closest('.poly-select').removeClass('loading');
            $('[name="industry"]').prop('disabled', false);

        }
    };

    var styleSelector = {
        init: function(){
            $('[name="style"]').closest('.poly-select').addClass('loading');
            $('[name="style"]').prop('disabled', true);
        },
        update:function($data){
            $('[name="style"]').html($data);
        },
        reset:function($class){
            $('[name="style"]').removeClass($class);
        },
        updated:function($class){
            $('[name="style"]').addClass($class);
        },               
        after: function(){
            $('[name="style"]').closest('.poly-select').removeClass('loading');
            $('[name="style"]').prop('disabled', false);
        }
    };

    var sizeSelector = {
        init: function(){
            $('[name="size"]').closest('.poly-select').addClass('loading');
            $('[name="size"]').prop('disabled', true);
        },
        update:function($data){
            $('[name="size"]').html($data);
        },
        reset:function($class){
            $('[name="size"]').removeClass($class);
        },
        updated:function($class){
            $('[name="size"]').addClass($class);
        },               
        after: function($class){
            $('[name="size"]').closest('.poly-select').removeClass('loading');
            $('[name="size"]').prop('disabled', false);
        }
    };

    var resetVal = {
        init: function(){
            $('[name="type"]').val('');
            $('[name="industry"]').val('');
            $('[name="style"]').val('');
            $('[name="size"]').val('');
        }
    };
    
    var typesChange = {
        init: function(){
            $('.product-search').on('change', '[name="type"]', function(){
                var url = $(this).closest('form').data('url');
                var data = {
                    'action'    : 'product_search', 
                    'type'      : $('[name="type"]').val(),
                    'industry'  : $('[name="industry"]').val(), 
                    'style'     : $('[name="style"]').val(),
                    'size'      : $('[name="size"]').val()               
                }
                $selector = $('[name="type"]');
                $thisClass = 'updated-from-type';

                if(!$selector.hasClass('updated-from-industry') ) {
                    industrySelector.init();
                }
                if(!$selector.hasClass('updated-from-style') ) {
                    styleSelector.init();
                }
                if(!$selector.hasClass('updated-from-size') ) {
                    sizeSelector.init();
                }
                jQuery.post(url, data, function(response) {
                    var json = $.parseJSON( response );
                    if(!$selector.hasClass('updated-from-industry') ) {
                        industrySelector.update(json.industries);
                        industrySelector.after();
                        if ( $selector.val() == '' ) {
                            industrySelector.reset($thisClass);
                        } else {
                            industrySelector.updated($thisClass);
                        }
                    }
                    if(!$selector.hasClass('updated-from-style') ) {
                        styleSelector.update(json.styles);
                        styleSelector.after();
                        if ( $selector.val() == '' ) {
                            styleSelector.reset($thisClass);
                        } else {
                            styleSelector.updated($thisClass);
                        }                        
                    }
                    if(!$selector.hasClass('updated-from-size') ) {
                        sizeSelector.update(json.sizes);
                        sizeSelector.after();
                        if ( $selector.val() == '' ) {
                            sizeSelector.reset($thisClass);
                        } else {
                            sizeSelector.updated($thisClass);
                        }                        
                    }
                    if( json.count > 0 ){
                        $('.product-search__count').html( json.count );
                    }
                });
            });
        }
    };
    var industryChange = {
        init: function(){
            $('.product-search').on('change', '[name="industry"]', function(){
                var url = $(this).closest('form').data('url');
                var data = {
                    'action'    : 'product_search', 
                    'type'      : $('[name="type"]').val(),
                    'industry'  : $('[name="industry"]').val(), 
                    'style'     : $('[name="style"]').val(),
                    'size'      : $('[name="size"]').val()               
                }
                $selector = $('[name="industry"]');
                $thisClass = 'updated-from-industry';

                if(!$selector.hasClass('updated-from-type') ) {
                    typeSelector.init();
                }
                if(!$selector.hasClass('updated-from-style') ) {
                    styleSelector.init();
                }
                if(!$selector.hasClass('updated-from-size') ) {
                    sizeSelector.init();
                }
                
                
                jQuery.post(url, data, function(response) {
                    var json = $.parseJSON( response );
                    if(!$selector.hasClass('updated-from-type') ) {
                        typeSelector.update(json.types);
                        typeSelector.after();
                        if ( $selector.val() == '' ) {
                            typeSelector.reset($thisClass);
                        } else {
                            typeSelector.updated($thisClass);
                        }   
                    }
                    if(!$selector.hasClass('updated-from-style') ) {
                        styleSelector.update(json.styles);
                        styleSelector.after();
                        if ( $selector.val() == '' ) {
                            styleSelector.reset($thisClass);
                        } else {
                            styleSelector.updated($thisClass);
                        }   
                    }
                    if(!$selector.hasClass('updated-from-size') ) {
                        sizeSelector.update(json.sizes);
                        sizeSelector.after();
                        if ( $selector.val() == '' ) {
                            sizeSelector.reset($thisClass);
                        } else {
                            sizeSelector.updated($thisClass);
                        }   
                    }
                    
                    if( json.count > 0 ){
                        $('.product-search__count').html( json.count );
                    }           

                });
            });
        }
    };
    var styleChange = {
        init: function(){
            $('.product-search').on('change', '[name="style"]', function(){
                var url = $(this).closest('form').data('url');
                var data = {
                    'action'    : 'product_search', 
                    'type'      : $('[name="type"]').val(),
                    'industry'  : $('[name="industry"]').val(), 
                    'style'     : $('[name="style"]').val(),
                    'size'      : $('[name="size"]').val()               
                }
                $selector = $('[name="style"]');
                $thisClass = 'updated-from-style';

                if(!$selector.hasClass('updated-from-type') ) {
                    typeSelector.init();
                }
                if(!$selector.hasClass('updated-from-industry') ) {
                    industrySelector.init();
                }
                if(!$selector.hasClass('updated-from-size') ) {
                    sizeSelector.init();
                }
                
                jQuery.post(url, data, function(response) {
                    var json = $.parseJSON( response );
                    if(!$selector.hasClass('updated-from-type') ) {
                        typeSelector.update(json.types);
                        typeSelector.after();
                        if ( $selector.val() == '' ) {
                            typeSelector.reset($thisClass);
                        } else {
                            typeSelector.updated($thisClass);
                        }   
                    }
                    if(!$selector.hasClass('updated-from-industry') ) {
                        industrySelector.update(json.industries);
                        industrySelector.after();
                        if ( $selector.val() == '' ) {
                            industrySelector.reset($thisClass);
                        } else {
                            industrySelector.updated($thisClass);
                        }
                    }
                    if(!$selector.hasClass('updated-from-size') ) {
                        sizeSelector.update(json.sizes);
                        sizeSelector.after();
                        if ( $selector.val() == '' ) {
                            sizeSelector.reset($thisClass);
                        } else {
                            sizeSelector.updated($thisClass);
                        }   
                    }
                    if( json.count > 0 ){
                        $('.product-search__count').html( json.count );
                    }                
                });
            });
        }
    }; 
    var sizeChange = {
        init: function(){
            $('.product-search').on('change', '[name="size"]', function(){
                var url = $(this).closest('form').data('url');
                var data = {
                    'action'    : 'product_search', 
                    'type'      : $('[name="type"]').val(),
                    'industry'  : $('[name="industry"]').val(), 
                    'style'     : $('[name="style"]').val(),
                    'size'      : $('[name="size"]').val()               
                }
                $selector = $('[name="size"]');
                $thisClass = 'updated-from-size';

                if(!$selector.hasClass('updated-from-type') ) {
                    typeSelector.init();
                }
                if(!$selector.hasClass('updated-from-industry') ) {
                    industrySelector.init();
                }
                if(!$selector.hasClass('updated-from-style') ) {
                    styleSelector.init();
                }
                jQuery.post(url, data, function(response) {
                    var json = $.parseJSON( response );
                    if(!$selector.hasClass('updated-from-type') ) {
                        typeSelector.update(json.types);
                        typeSelector.after();
                        if ( $selector.val() == '' ) {
                            typeSelector.reset($thisClass);
                        } else {
                            typeSelector.updated($thisClass);
                        }   
                    }
                    if(!$selector.hasClass('updated-from-industry') ) {
                        industrySelector.update(json.industries);
                        industrySelector.after();
                        if ( $selector.val() == '' ) {
                            industrySelector.reset($thisClass);
                        } else {
                            industrySelector.updated($thisClass);
                        }
                    }
                    if(!$selector.hasClass('updated-from-style') ) {
                        styleSelector.update(json.styles);
                        styleSelector.after();
                        if ( $selector.val() == '' ) {
                            styleSelector.reset($thisClass);
                        } else {
                            styleSelector.updated($thisClass);
                        }   
                    }

                    if( json.count > 0 ){
                        $('.product-search__count').html( json.count );
                    }                    
                });
            });
        }
    };            
 
    var Boot = {
        start: function () {
            resetVal.init();
            typesChange.init();
            industryChange.init();
            styleChange.init();
            sizeChange.init();
        },
        resized: function () {
        },
      };
    
    $(document).ready(function () {
        Boot.start();
    });    
})(jQuery);